const list = {
    path: 'payChannelInterface',
    component: resolve => require(['@/pages/admin/platform/payChannelInterface'], resolve)
}

export default list